module.exports = __webpack_public_path__ + "img/Check.5d5a4f97.svg";